import { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { cn } from "@/lib/cn";
import ConfirmModal from "@/components/ui/ConfirmModal";
import { Palette, Layers, LogOut, Sparkles, Package } from "lucide-react";

const navItems = [
  { path: "/styles", label: "風格列表", icon: Palette },
  { path: "/batch", label: "批量製作", icon: Layers },
  { path: "/releases", label: "版本管理", icon: Package },
];

export default function DashboardLayout() {
  const location = useLocation();
  const logout = useAuthStore((state) => state.logout);
  const [confirmLogout, setConfirmLogout] = useState(false);

  return (
    <div className="min-h-screen flex bg-ceramic-50">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-ceramic-200 flex flex-col">
        <div className="p-6 border-b border-ceramic-200">
          <div className="flex items-center gap-2">
            <Sparkles className="w-6 h-6 text-accent" />
            <h1 className="text-lg font-semibold text-ceramic-900">Fig It Admin</h1>
          </div>
          <p className="text-xs text-ceramic-500 mt-1">官方模板庫管理</p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            const Icon = item.icon;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "flex items-center gap-3 px-4 py-3 rounded-lg transition-colors",
                  isActive
                    ? "bg-ceramic-100 text-ceramic-900 font-medium"
                    : "text-ceramic-600 hover:bg-ceramic-50 hover:text-ceramic-900"
                )}
              >
                <Icon className="w-5 h-5" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-ceramic-200">
          <button
            onClick={() => setConfirmLogout(true)}
            className="flex items-center gap-3 px-4 py-3 w-full rounded-lg text-ceramic-600 hover:bg-red-50 hover:text-red-600 transition-colors"
          >
            <LogOut className="w-5 h-5" />
            登出
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>

      <ConfirmModal
        open={confirmLogout}
        title="確定要登出嗎？"
        description="登出後需重新輸入帳號密碼，未儲存的編輯內容將會遺失。"
        confirmLabel="登出"
        cancelLabel="取消"
        destructive
        onConfirm={() => {
          setConfirmLogout(false);
          logout();
        }}
        onCancel={() => setConfirmLogout(false)}
      />
    </div>
  );
}
